const PICKUP = 'filters[Pickup]';
const SAME_DAY = 'filters[SameDay]';
const PICKUP_FILTER_START = 'filters[Pickup]';
const SAME_DAY_FILTER_START = 'filters[SameDay]';
const SHIP_TO_HOME = 'filters[ShipToHome]';
const SHIP_TO_HOME_FILTER_START = 'filters[ShipToHome]';

export {
    PICKUP, SAME_DAY, PICKUP_FILTER_START, SAME_DAY_FILTER_START, SHIP_TO_HOME, SHIP_TO_HOME_FILTER_START
};
